module.exports = __webpack_public_path__ + "static/media/imgactivea.268fa6c1.webp";